import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';

import * as env from '../../../environments/environment';
import { EmailNotification } from 'src/app/models/notifications';
import { getNotifications } from 'src/app/store';
import { ApplicationState, GetNotifications, UpdateNotification, UpdateNotificationActive } from 'src/app/store/application';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})

export class NotificationsComponent implements OnInit {

  private ngUnsubscribe: Subject<void> = new Subject();
  notifications$!: Observable<EmailNotification[]>;
  notifications: EmailNotification[] = [];
  dow = [
    { value: 1, name: 'Saturday' },
    { value: 2, name: 'Sunday' },
    { value: 3, name: 'Monday' },
    { value: 4, name: 'Tuesday' },
    { value: 5, name: 'Wednesday' },
    { value: 6, name: 'Thursday' },
    { value: 7, name: 'Friday' }
  ];
  setTime = false;

  notificationsForm: UntypedFormGroup;
  editRowIdx = -1;
  isLoaded = false;
  ogValues: any;
  previewContent: SafeHtml | undefined;
  webroot = 'https://localhost:7281';

  constructor(
    private store: Store<ApplicationState>,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    this.notifications$ = this.store.select(getNotifications);
    this.notificationsForm = this.formBuilder.group({
      rows: this.formBuilder.array([])
    });
  }

  get rowsArr() {
    return this.notificationsForm.get('rows') as UntypedFormArray;
  }

  ngOnInit(): void {
    this.store.dispatch(GetNotifications());

    this.notifications$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((notifications: EmailNotification[]) => {
        this.notifications = notifications;
        if (notifications.length > 0 && this.isLoaded === false) {
          this.rowsArr.clear();
          notifications.forEach((n) => {
            const ctrls = this.initRows(n);
            this.rowsArr.push(ctrls);
          })
          this.isLoaded = true;
          for (let i = 0; i < this.rowsArr.length; i++) {
            this.rowsArr.at(i).get('dayOfWeek')?.disable();
            this.rowsArr.at(i).get('timeOfDay')?.setValue(notifications[i].tod);
            this.rowsArr.at(i).get('timeOfDay')?.disable()
            this.rowsArr.at(i).get('nickname')?.disable();
            this.rowsArr.at(i).get('deadlineDayOfWeek')?.disable();
            this.rowsArr.at(i).get('deadlineTimeOfDay')?.setValue(notifications[i].deadlineTOD);
            this.rowsArr.at(i).get('deadlineTimeOfDay')?.disable()
          }
        }
      });

    if (env.environment.environment === 'uat') {
      this.webroot = 'https://tsuat.dnv.org';
    } else if (env.environment.environment === 'prod') {
      this.webroot = 'https://ts.dnv.org';
    }
  }


  initRows(em: EmailNotification) {
    return this.formBuilder.group({
      notificationId: em.id,
      dayOfWeek: em.dayOfTheWeek,
      timeOfDay: (em.tod.hour < 10 ? '0' + em.tod.hour : em.tod.hour) + ':' + (em.tod.minute < 10 ? '0' + em.tod.minute : em.tod.minute),
      isActive: em.active,
      nickname: em.nickName,
      deadlineDayOfWeek: em.deadlineDayOfTheWeek,
      deadlineTimeOfDay: (em.deadlineTOD.hour < 10 ? '0' + em.deadlineTOD.hour : em.deadlineTOD.hour) + ':' + (em.deadlineTOD.minute < 10 ? '0' + em.deadlineTOD.minute : em.deadlineTOD.minute)
    });
  }

  setRowValues(i: number) {
    const rowCtrls = this.rowsArr.at(i);
    const dow = this.ogValues.dayOfWeek;
    rowCtrls.get('dayOfWeek')?.setValue(dow);
    rowCtrls.get('timeOfDay')?.setValue({ hour: this.ogValues.timeOfDay.hour, minute: this.ogValues.timeOfDay.minute });
    rowCtrls.get('nickname')?.setValue(this.ogValues.nickname);
    rowCtrls.get('deadlineTimeOfDay')?.setValue({ hour: this.ogValues.deadlineTimeOfDay.hour, minute: this.ogValues.deadlineTimeOfDay.minute });
  }

  getCtrl(i: number): any {
    return this.rowsArr.at(i).get('dayOfWeek') as UntypedFormControl;
  }

  previewEmail(idx: number, content: any): void {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg'
    };
    const id = this.rowsArr.at(idx).get('notificationId')?.value;
    const notification = id !== null ? this.notifications.filter(n => n.id === id)[0] : this.notifications[0];
    const today = new Date();
    let targetDeadline = this.rowsArr.at(idx).get('deadlineDayOfWeek')?.value - 2;
    if (targetDeadline === 0) {
      targetDeadline = 7;
    } else if (targetDeadline === -1) {
      targetDeadline = 6;
    }
    const targetDeadlineDate = this.addDays(today, (targetDeadline - today.getDay()));
    const timeHour = this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.hour > 12 ? this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.hour - 12 : this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.hour;
    const timeMinute = this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.minute < 10 ? '0' + this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.minute : this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.minute;
    const timeAPM = this.rowsArr.at(idx).get('deadlineTimeOfDay')?.value.hour > 11 ? 'pm' : 'am';
    const deadline = (timeHour === 0 ? 12 : timeHour) + ':' + timeMinute + ' ' + timeAPM + ' on ' + targetDeadlineDate.toLocaleDateString('default', { weekday: 'long' }) + ', ' + targetDeadlineDate.toLocaleString('default', { month: 'long' }) + ' ' + targetDeadlineDate.getDate();
    if (notification !== null) {
      if (id !== null) {
        this.previewContent = this.sanitizer.bypassSecurityTrustHtml(notification.defaultEmailTemplate.replace('{0}', deadline).replace('{1}', this.webroot).replace('text-align: center;', 'text-align: center;padding-bottom: 15px;'));
      } else {
        // new email not yet saved
        this.previewContent = this.sanitizer.bypassSecurityTrustHtml(notification.defaultEmailTemplate.replace('{0}', '[DEADLINE TIME] on [DEADLINE DATE]').replace('{1}', this.webroot).replace('text-align: center;', 'text-align: center;padding-bottom: 15px;'));
      }

    }
    this.modalService.open(content, ngbModalOptions);
  }

  editRow(idx: number): void {
    this.rowsArr.at(idx).get('dayOfWeek')?.enable();
    this.rowsArr.at(idx).get('timeOfDay')?.enable();
    this.rowsArr.at(idx).get('nickname')?.enable();
    this.rowsArr.at(idx).get('deadlineDayOfWeek')?.enable();
    this.rowsArr.at(idx).get('deadlineTimeOfDay')?.enable();
    this.editRowIdx = idx;
    this.ogValues = this.rowsArr.at(idx).value;

  }

  saveRow(idx: number): void {
    this.editRowIdx = -1;
    // console.log(this.rowsArr.at(idx).value);
    const formVals = this.rowsArr.at(idx).value;

    const hrs = formVals.timeOfDay.hour;
    const mins = formVals.timeOfDay.minute;
    const noti = {
      emailNotificationId: formVals.notificationId ? formVals.notificationId : 0,
      tod: { hour: hrs, minute: mins },
      dayOfTheWeek: formVals.dayOfWeek,
      nickname: formVals.nickname,
      deadlineTOD: { hour: formVals.deadlineTimeOfDay.hour, minute: formVals.deadlineTimeOfDay.minute },
      deadlineDayOfTheWeek: formVals.deadlineDayOfWeek
    } as unknown as EmailNotification;
    this.store.dispatch(UpdateNotification({ notification: noti }));

    this.rowsArr.at(idx).get('dayOfWeek')?.disable();
    this.isLoaded = false;
  }

  updateActive(idx: number, evt: any): void {
    this.isLoaded = false;
    const formVals = this.rowsArr.at(idx).value;
    const noti = {
      emailNotificationId: formVals.notificationId,
      active: evt?.checked
    } as unknown as EmailNotification;
    this.store.dispatch(UpdateNotificationActive({ notification: noti }));
  }

  cancelRow(idx: number): void {
    if (this.ogValues) {
      this.setRowValues(idx);
      this.editRowIdx = -1;
      this.rowsArr.at(idx).get('dayOfWeek')?.disable();
      this.rowsArr.at(idx).get('timeOfDay')?.disable();
      this.rowsArr.at(idx).get('nickname')?.disable();
      this.rowsArr.at(idx).get('deadlineDayOfWeek')?.disable();
      this.rowsArr.at(idx).get('deadlineTimeOfDay')?.disable();
    } else {
      // cacnel from adding new row
      this.rowsArr.removeAt(idx);
    }

  }

  getHoursCSS(i: number): boolean {
    const h = this.rowsArr.at(i).get('timeOfDayHr')?.value;
    if (h < 10) {
      return true;
    }
    return false;
  }

  setBtnsDisabled(i: number) {
    return this.rowsArr.at(i).get('isActive')?.value == false ? '' : null;
  }

  addNotification(): void {
    this.ogValues = null;
    const blankNotification: EmailNotification = {
      dayOfTheWeek: 1,
      tod: { hour: 0, minute: 0 },
      active: true,
      nickName: '',
      deadlineDayOfTheWeek: 1,
      deadlineTOD: { hour: 0, minute: 0 }
    } as unknown as EmailNotification;
    const ctrls = this.initRows(blankNotification);
    this.rowsArr.push(ctrls);
    this.editRowIdx = this.rowsArr.length - 1;
    this.rowsArr.at(this.editRowIdx).get('timeOfDay')?.setValue({ hour: 0, minute: 0 });
    this.rowsArr.at(this.editRowIdx).get('deadlineTimeOfDay')?.setValue({ hour: 0, minute: 0 });
  }

  enablePreview(i: number): boolean | null {
    return this.notifications[i] === undefined ? true : null;
  }

  validate(i: number): boolean | null {
    const isValid = this.rowsArr.at(i)?.get('nickname')?.invalid || this.rowsArr.at(i)?.get('timeOfDay')?.invalid || this.rowsArr.at(i)?.get('deadlineTimeOfDay')?.invalid;
    return isValid === true ? isValid : null;
  }

  addDays(date: Date, days: number) {
    const result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
  }
}
